import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactUsService } from '../core/services/contact-us.service';
import { LanguageService } from '../core/services/language.service';
import { ProductCategoryFieldsComponent } from '../core/components/product-category-fields/product-category-fields.component';


@Component({
  selector: 'app-get-quote',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ProductCategoryFieldsComponent],
  templateUrl: './get-quote.component.html',
  styleUrl: './get-quote.component.css'
})
export class GetQuoteComponent implements OnInit{
  @Output()
  formReady = new EventEmitter<FormGroup>();

  constructor(private fb: FormBuilder, private contactUsService: ContactUsService, private languageService: LanguageService) {}

  form: FormGroup;

  ngOnInit() {
    const lang = this.languageService.getLanguageFromUrl();
    this.lang = lang;

    this.form = this.fb.group({
      userType: [''],
      productCategory: ['', [Validators.required]],
      productCategoryId: [''],
      otherInsurance: [''],
      product: ['', [Validators.required]],
      productId: [''],
      otherProduct: [''],
      region: [lang === 'fr-fr' ? 'FR' : lang === 'en-us' ? 'US' : '', lang === 'en' ? [Validators.required] : []],
      description: ['', [Validators.required, Validators.minLength(20)]]
    });

    this.formReady.emit(this.form);

    this.contactUsService.getDictionary(lang).subscribe(() => {
      this.userTypes = this.listLabels.userType?.split(';') || [];
    });
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.form.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }

  userTypes: string[] = [];

  lang: string = '';

  get labels() { return this.contactUsService.commonLabels; }
  get placeholders() { return this.contactUsService.placeholderTextLabels; }
  get messages() { return this.contactUsService.messageLabels; }

  get listLabels() { return this.contactUsService.listLabels; }





}
